import { render, staticRenderFns } from "./WidgetEditorContentAreaComponent.vue?vue&type=template&id=f631b0e6&"
import script from "./WidgetEditorContentAreaComponent.vue?vue&type=script&lang=js&"
export * from "./WidgetEditorContentAreaComponent.vue?vue&type=script&lang=js&"
import style0 from "./WidgetEditorContentAreaComponent.vue?vue&type=style&index=0&id=f631b0e6&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports